import { render, staticRenderFns } from "./detailLapiaza.vue?vue&type=template&id=e8a39d84&scoped=true&"
import script from "./detailLapiaza.vue?vue&type=script&lang=js&"
export * from "./detailLapiaza.vue?vue&type=script&lang=js&"
import style0 from "./detailLapiaza.vue?vue&type=style&index=0&id=e8a39d84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a39d84",
  null
  
)

export default component.exports